import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import CookieSettingsModal from '../shared/CookieSettingsModal';

export default function LegalPage({ title, content, lastUpdated }) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with prominent back button */}
      <div className="bg-white shadow-sm border-b-2 border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={() => navigate(isAuthenticated ? '/dashboard' : '/')}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#5a20ff] text-white text-sm font-semibold rounded-lg shadow-sm hover:bg-[#4a1ad6] transition-all duration-200"
            >
              <Home className="w-4 h-4 flex-shrink-0" />
              <span>Back to {isAuthenticated ? 'Dashboard' : 'Home'}</span>
            </button>
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-white text-gray-700 text-sm font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
            >
              <ArrowLeft className="w-4 h-4 flex-shrink-0" />
              <span className="hidden sm:inline">Go Back</span>
            </button>
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h1>
          {lastUpdated && (
            <p className="text-sm text-gray-500 mt-2">
              Last Updated: {lastUpdated}
            </p>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="bg-white rounded-lg shadow-sm border-2 border-gray-200 p-6 sm:p-8">
          <div className="prose prose-indigo max-w-none">
            {content}
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-8 bg-blue-50 rounded-lg p-6 border border-blue-100">
          <h3 className="text-lg font-semibold text-blue-900 mb-4">Legal Documents</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <a 
              href="/legal/privacy" 
              className="text-blue-700 hover:text-blue-800 font-medium hover:underline"
            >
              Privacy Policy →
            </a>
            <a 
              href="/legal/terms" 
              className="text-blue-700 hover:text-blue-800 font-medium hover:underline"
            >
              Terms of Service →
            </a>
            <a 
              href="/legal/cookies" 
              className="text-blue-700 hover:text-blue-800 font-medium hover:underline"
            >
              Cookie Policy →
            </a>
            <button
              onClick={() => setShowCookieSettings(true)}
              className="text-left text-blue-700 hover:text-blue-800 font-medium hover:underline"
            >
              Cookie Settings →
            </button>
          </div>
        </div>

        {/* Contact */}
        <div className="mt-6 text-center text-sm text-gray-600">
          Questions? Contact us at{' '}
          <a href="mailto:hello@eq.community" className="text-indigo-600 hover:text-indigo-700 font-medium">
            hello@eq.community
          </a>
        </div>
      </div>

      {/* Cookie Settings Modal */}
      <CookieSettingsModal 
        isOpen={showCookieSettings} 
        onClose={() => setShowCookieSettings(false)} 
      />
    </div>
  );
}

